//
//
//
//
//
//
//
//

export default {
  name: "OCCResult",
  props: {
    result: Object,
    openInNewWindow: Boolean,
    formatDate: Function,
  },
  computed: {
    date() {
      return this.formatDate(this.result.itemDate, "MMM. dd, yyyy");
    },
  },
};
